<template>
  <div class="search-page bg-w" v-loading="loading">
    <h1 class="tx-c pt10">{{searchParams.name}}</h1>
    <div class="w120 mc mt20">
      <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" >
        <el-col class="flex-box al-c" :span="2">
          <el-button class="mb10 ml10" type="primary" @click="onSearch">查询</el-button>
        </el-col>
      </Sift>

      <el-table
        class="mt20 table w100"
        header-row-class-name="table-head"
        row-class-name="cu-p"
        stripe
        :data="list"
      >
        <el-table-column align="center" label="序号" width="50px" v-if="tableColumnList.length">
          <template slot-scope="scope">{{ current * size - size + scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          align="center"
          :prop="item.fieldName"
          :label="item.showName"
        >
          <template slot-scope="scope" v-if="item.fieldType=='0'||item.fieldType=='1'">
            <span>{{translateValue(scope.row[item.fieldName], item.exchange)}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!tableColumnList.length"></el-table-column>
      </el-table>
      <div class="mt20 flex-box">
        <div class="flex-1"></div>
        <el-pagination
          background
          @size-change="changeSize"
          @current-change="changePage"
          :current-page="current"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Sift from "@/components/sift/Sift";
import {sysDatasourceQuerySearchList, sysDatasourceQueryId} from '@/api/management/search'

export default {
  name: "Search",
  data() {
    return {
      current: 1,
      size: 10,
      total: 0,
      baseUrl: process.env.BASE_URL,
      siftData: [],
      searchParams: {},
      list: [],
      tableColumnList: [],
      loading: false,
    };
  },
  components: {
    Sift,
  },
  computed: {
    
  },
  filters: {
  },
  watch: {
    
  },
  created() {
    this.sysDatasourceQueryId();
  },
  methods: {
    sysDatasourceQueryId(){
      this.loading = true;
      sysDatasourceQueryId(this.$route.query.id)
      .then(({data}) => {
        if(data.code == 0){
          this.searchParams = data.data
          this.siftDataHandler();
          this.tableColumnHandler();
          this.$nextTick(() => {
            this.onSearch()
          })
        }else {
          this.$message.error(data.msg || '请求出错')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    siftDataHandler(){
      const queryCondDefList = this.searchParams.queryCondDefList;
      queryCondDefList.forEach(item => {
        switch (item.type) {
          case '0':
            this.siftData.push({
              type: 'text',
              key: item.queryField,
              label: item.showName,
            })
            break;
          case '1':
            let selectData = [];
            var exchange = JSON.parse(item.exchange) || []
            exchange.forEach(e => {
              selectData.push({
                value: e.value,
                label: e.name
              })
            })
            this.siftData.push({
              type: 'select',
              key: item.queryField,
              label: item.showName,
              data: selectData,
            })
            break;
          case '2':
            let selectsData = [];
            var exchange = JSON.parse(item.exchange) || []
            exchange.forEach(e => {
              selectsData.push({
                value: e.value,
                label: e.name
              })
            })
            this.siftData.push({
              type: 'selects',
              key: item.queryField,
              label: item.showName,
              data: selectsData,
            })
            break;
          case '3':
            if(item.queryType === '1'){
              this.siftData.push({
                type: 'bedate',
                key: item.queryField,
                label: item.showName,
                sysDatasourceQuery: true,
              })
            }else {
              this.siftData.push({
                type: 'date',
                key: item.queryField,
                label: item.showName,
                sysDatasourceQuery: true,
              })
            }
            break;
        }
      });
    },
    tableColumnHandler(){
      const queryResultDefList = this.searchParams.queryResultDefList
      queryResultDefList.forEach(item => {
        this.tableColumnList.push({
          fieldName: item.fieldName,
          showName: item.showName,
          fieldType: item.fieldType,
          exchange: item.exchange,
        })
      });
    },
    translateValue(fieldName, exchange){
      return fieldName
    },
    changePage(page){
      this.current = page;
      this.getList()
    },
    changeSize(value) {
      this.size = value;
      this.onSearch();
    },
    onSearch(){
      this.current = 1
      this.getList()
    },
    getList(){
      this.loading = true;
      let searchData = this.$refs.needSift.getValue();
      const queryCondDefList = this.searchParams.queryCondDefList;
      let bedateKeys = []
      queryCondDefList.forEach((item, index) => {
        if(item.type==='3'&&item.queryType==='1'){
          bedateKeys.push(item.queryField)
        }
      })
      let queryParams = []
      for(let item in searchData){
        if(bedateKeys.includes(item)){
          queryParams.push({
            key: item,
            value: `${searchData[item][0]},${searchData[item][1]}`
          })
        }else {
          queryParams.push({
            key: item,
            value: searchData[item]
          })
        }
      }
      let obj = {
        current: this.current,
        size: this.size,
        queryId: this.searchParams.id,
        queryParams,
      }
      sysDatasourceQuerySearchList(obj)
      .then(({data}) => {
        if(data.code == 0){
          this.list = data.data.records;
          this.total = data.data.total;
        }else {
          this.$message.error(data.msg || '请求出错')
        }
      }).finally(() => {
        this.loading = false
      })
    },
  }
};
</script>

<style lang="less" scoped>
.search-page {
  min-height: calc(100% - 160px);
}
</style>